<template>
  <div class="container container-table loginpage">
    <div class="row vertical-10p logincntrrow">
      <div class="container logincntr">
        <div class="text-center col-md-4 col-sm-offset-4 loginFormwrp">
          <!-- login form --><img src="/static/img/d2dvoyager-logo.png" class="center-block logina-logo">
          <form class="ui form loginForm" @submit.prevent="login">
            <div class="error loginModuleToperror"><span class="error " v-show="errors.has('username')">{{ errors.first('username') }}</span></div>
            <div class="input-group" v-bind:class="errors.has('username') ? 'error' : ''" >
              <span class="input-group-addon">
                <i class="fa fa-user"></i>
              </span>
              <input  id="username" v-on:blur="validemail" v-validate="{ email: true }" class="form-control" name="username" placeholder="Email" type="text" v-model="username" required>

            </div>
            <div class="input-group">
              <span class="input-group-addon">
                <i class="fa fa-lock"></i>
              </span>
              <input id="password" type="password" placeholder="password" class="validate form-control" v-model="password" required>
            </div>
            <div class="loginsubmitwrp">
              Forgot Password? &nbsp;
              <a href="javascript:" @click="forgetpassword">Reset here</a>
              <button type="submit" v-bind:class="'loginsubmit btn btn-primary btn-lg ' + loading">Login</button>
            </div>
          </form>
          <!-- errors -->
          <div v-if=response class="text-red">
            <p>{{response}}</p>
          </div>
        </div>
      </div>
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
  </div>
</template>

<script>
// import Simplert from 'vue2-simplert'
import $ from 'jquery'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  enableAutoClasses: true,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur|change',
  inject: true
}

Vue.use(VeeValidate, config)
// import CognitoAuth from '../cognito/index.js'
export default {
  name: 'Login',
  data (router) {
    return {
      section: 'Login',
      loading: '',
      username: '',
      response: '',
      XpiKey_prod: 'u03FsrDfnSvrtA0Elhue1PTl3Bl8dXl2S8J2rTg6',
      ApiURL_prod: 'https://8qa7idwg7g.execute-api.eu-west-1.amazonaws.com/prod',
      XpiKey_dev: 'EbaW0SGzDl10IolJeCeOP1HtYhWJsbNE1T1JJfJ0',
      ApiURL_dev: 'https://uwi5wigw7c.execute-api.eu-west-1.amazonaws.com/dev',
      XpiKey_qa: 'V8owcMdjPm8kyMW8IsQvi7SU23XTISp8awcpR3hb',
      ApiURL_qa: 'https://2ra71e8o9e.execute-api.eu-west-1.amazonaws.com/qa',
      password: '',
      error: null,
      clearcatch: true
    }
  },
  methods: {
    forgetpassword () {
      this.$router.replace('/forgetpassword')
    },
    validemail () {
      this.$validator.validate('username', this.username)
      if (this.fields.username.valid) {
        var emailCorrecter = String(this.username)
        emailCorrecter = emailCorrecter.split('.')[0].charAt(0).toUpperCase() + emailCorrecter.split('.')[0].slice(1) + '.' + emailCorrecter.split('.')[1].charAt(0).toUpperCase() + emailCorrecter.split('.')[1].slice(1) + '.' + emailCorrecter.split('.')[2]
        this.username = emailCorrecter
      }
    },
    login () {
      this.loading = true
      this.$pingpong.displayLoader()
      var emailCorrecter = String(this.username)
      emailCorrecter = emailCorrecter.split('.')[0].charAt(0).toUpperCase() + emailCorrecter.split('.')[0].slice(1) + '.' + emailCorrecter.split('.')[1].charAt(0).toUpperCase() + emailCorrecter.split('.')[1].slice(1) + '.' + emailCorrecter.split('.')[2]
      this.username = emailCorrecter
      var self = this
      this.$cognito.login(this.username, this.password)
        .then(result => {
          var data = result
          var logins = result.logins
          // let name = data.name
          console.log(data)
          if (data.newPasswordRequired === true) {
            var token = 'Bearer ' + data.session
            self.$parent.$store.commit('SET_USER', self.username)
            self.$parent.$store.commit('SET_LOGINS', logins)
            self.$parent.$store.commit('SET_TOKEN', token)
            window.localStorage.setItem('user', data.attributes.username)
            window.localStorage.setItem('username', data.attributes.username)
            window.localStorage.setItem('email', data.attributes.email)
            window.localStorage.setItem('token', token)
            window.localStorage.setItem('noauth', 'false')
            self.getApptype()
            self.$pingpong.hideloader()
            this.$router.replace('/changepassword')
            return
          } else if (data.newPasswordRequired === false) {
            console.log(result.result.accessToken.payload.username)
            window.localStorage.setItem('user', result.result.idToken.payload['cognito:username'])
            window.localStorage.setItem('username', result.result.idToken.payload['cognito:username'])
            window.localStorage.setItem('email', result.result.idToken.payload.email)
            window.localStorage.setItem('token', result.result.refreshToken.token)
            window.localStorage.setItem('name', result.result.idToken.payload['name'])
            window.localStorage.setItem('jwtToken', result.result.idToken.jwtToken)
            window.localStorage.setItem('refreshToken', result.result.refreshToken.token)
            window.localStorage.setItem('noauth', 'false')
            self.$parent.$store.commit('SET_LOGINS', logins)
            self.getApptype()
            self.clearcatch = false
            self.$pingpong.hideloader()
            this.$router.replace('/')
            return
          }
        }).catch(function (error) {
          console.log(error)
          if (error.code === 'PasswordResetRequiredException') {
            self.$pingpong.hideloader()
            self.$router.replace('/passwordreset')
            self.passworderr(error)
            return
          }
          // this.error = err
          if (self.clearcatch === true) {
            window.localStorage.setItem('noauth', 'true')
            window.localStorage.setItem('user', null)
            window.localStorage.setItem('email', null)
            window.localStorage.setItem('username', null)
            window.localStorage.setItem('token', null)
            window.localStorage.setItem('XpiKey', null)
            window.localStorage.setItem('ApiURL', null)
            self.$pingpong.hideloader()
            self.displaypopuperr(error)
          }
        })
      // this.$cognito.isAuthenticated().then(function (params) {
      //   console.log(params)
      // })
      // .then(err => {
      //   if (err !== undefined) {
      //     this.error = err
      //     console.log(err)
      //     window.localStorage.setItem('user', null)
      //     window.localStorage.setItem('email', null)
      //     window.localStorage.setItem('username', null)
      //     window.localStorage.setItem('token', null)
      //     window.localStorage.setItem('XpiKey', null)
      //     window.localStorage.setItem('ApiURL', null)
      //     self.$pingpong.hideloader()
      //     this.displaypopuperr()
      //   }
      return
      // })
    },
    displaypopuperr (msg) {
      console.log(msg)
      // code: "NotAuthorizedException", name: "NotAuthorizedException", message: "Incorrect username or password."
      let msgarr = msg
      let code = msgarr.code
      console.log(code)
      let name = msgarr.name
      let message = msgarr.message
      let err = {
        title: name,
        message: message,
        type: 'error',
        customClass: 'error'
      }
      this.$Simplert.open(err)
    },
    passworderr (msg) {
      console.log(msg)
      // code: "NotAuthorizedException", name: "NotAuthorizedException", message: "Incorrect username or password."
      let msgarr = msg
      let code = msgarr.code
      console.log(code)
      // let name = msgarr.name
      let message = msgarr.message
      let err = {
        title: 'Password Message',
        message: message,
        type: 'error',
        customClass: 'error'
      }
      this.$Simplert.open(err)
    },
    getApptype () {
      function getSubdomain (hostname) {
        var regexParse = new RegExp('[a-z-0-9]{2,63}[a-z.]{2,5}$')
        var urlParts = regexParse.exec(hostname)
        return hostname.replace(urlParts[0], '').slice(0, -1)
      }
      function getDomain (hostname) {
        var regexParse = new RegExp('[a-z-0-9]{2,63}[a-z.]{2,5}$')
        var urlParts = regexParse.exec(hostname)
        return urlParts[0]
      }
      var locationbr = getSubdomain(window.location.hostname)
      var domainname = getDomain(window.location.hostname)
      if ((domainname === 'd2dsuite.com' && locationbr === 'voyager') || (locationbr === 'd2d-da')) {
        window.localStorage.setItem('XpiKey', this.XpiKey_prod)
        window.localStorage.setItem('ApiURL', this.ApiURL_prod)
        window.localStorage.setItem('ENV', 'PROD')
        this.$parent.$store.commit('SET_APIURL', this.ApiURL_prod)
      } else if (domainname === 'amazonaws.com' || domainname === 'localhost' || locationbr === 'coredev') {
        window.localStorage.setItem('XpiKey', this.XpiKey_dev)
        window.localStorage.setItem('ApiURL', this.ApiURL_dev)
        this.$parent.$store.commit('SET_APIURL', this.ApiURL_dev)
        window.localStorage.setItem('ENV', 'DEV')
      } else if (locationbr === 'coreqa') {
        window.localStorage.setItem('XpiKey', this.XpiKey_qa)
        window.localStorage.setItem('ApiURL', this.ApiURL_qa)
        this.$parent.$store.commit('SET_APIURL', this.ApiURL_qa)
        window.localStorage.setItem('ENV', 'QA')
      }
    },
    checkCreds () {
      var self = this
      self.$pingpong.displayLoader()
      self.getApptype()
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/UserAuthentication',
        data: { 'user-id': self.username },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          // self.$pingpong.hideloader()
        },
        success: function (data) {
          console.log(data['user-data'])
          if (data['user-data'] === undefined || data['user-data'] === null) {
            // self.$pingpong.hideloader()
          }
          data = data['user-data']
          // var mydata = data[0]['name']
          // data[0]['name'] = [].concat(...mydata)
          console.log(data)
          data = JSON.parse(data)
          if (data) {
            var token = 'Bearer ' + data.token
            self.$parent.$store.commit('SET_USER', self.username)
            this.$store.commit('SET_TOKEN', token)
            if (window.localStorage) {
              window.localStorage.setItem('user', self.username)
              window.localStorage.setItem('username', data.name)
              window.localStorage.setItem('email', data.email)
              window.localStorage.setItem('token', data.email)
              // window.localStorage.setItem('token', token)
            }
            self.$router.push('/')
          } else {
            window.localStorage.setItem('user', null)
            window.localStorage.setItem('email', null)
            window.localStorage.setItem('username', null)
            window.localStorage.setItem('token', null)
            window.localStorage.setItem('XpiKey', null)
            window.localStorage.setItem('ApiURL', null)
            self.$pingpong.hideloader()
            self.displaypopuperr()
            return
          }
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.displaypopuperr()
        }
      })
      /* Making API call to authenticate a user */
      /*
      api.request('post', '/login', {username, password})
      .then(response => {
        this.toggleLoading()

        var data = response.data
        /* Checking if error object was returned from the server */
      /*
              if (data.error) {
                var errorName = data.error.name
                if (errorName) {
                  this.response = errorName === 'InvalidCredentialsError'
                  ? 'Username/Password incorrect. Please try again.'
                  : errorName
                } else {
                  this.response = data.error
                }

                return
              }
             /* Setting user in the state and caching record to the localStorage
              if (data.user) {
                var token = 'Bearer ' + data.token

                this.$store.commit('SET_USER', data.user)
                this.$store.commit('SET_TOKEN', token)

                if (window.localStorage) {
                  window.localStorage.setItem('user', JSON.stringify(data.user))
                  window.localStorage.setItem('token', token)
                }
                this.$router.push(data.redirect)
              }
            })
            .catch(error => {
              this.$store.commit('TOGGLE_LOADING')
              console.log(error)

              this.response = 'Server appears to be offline'
              this.toggleLoading()
            })
          },
          toggleLoading () {
            this.loading = (this.loading === '') ? 'loading' : ''
          },
          resetResponse () {
            this.response = ''
          }
          */
    }
  },
  computed: {
    // ...mapFields({
    //   nameFlags: 'username'
    // })
  }
}
</script>

<style>
.input-group.error input {
    background-color: pink;
    color: #000;
}
.loginModuleToperror {
  margin-bottom: 10px;
}
.logina-logo {
  width: 215px !important;
  margin-bottom: 30px;
}
.error .simplert__body,
.error .simplert__title {
  color: red !important;
}
html,
body,
.container-table {
  height: 100%;
}
.container-table {
  display: table;
  color: white;
}
.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 20%;
}
.logo {
  width: 15em;
  padding: 3em;
}
.loginForm .input-group {
  padding-bottom: 1em;
  height: 4em;
}
.input-group input {
  height: 4em;
}
.logincntr {
  margin: 0 auto;
  /* top: 50%; */
  /* bottom: 50%; */
  /* position: absolute; */
  height: 175px;
  /* left: 50%; */
  /* right: 50%; */
  width: auto;
  text-align: center;
}
.loginFormwrp {
  position: relative;
  z-index: 2;
  width: auto;
  min-width: 500px;
  margin: auto;
  float: none;
  max-width: 500px;
}
.loginFormwrp input.form-control {
  padding-right: 58px;
}

.loginsubmit {
  position: absolute;
  top: 0px;
  z-index: 5;
  right: 0;
  line-height: 54px;
  padding: 0 10px;
  border-radius: 0;
}
.logincntrrow {
  width: 100vw;
  height: 100vh;
  margin: 0;
  position: relative;
  padding-top: 0;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
}

.spinner.login {
  top: 50%;
  margin: 0 auto;
  left: calc(50% - 70px);
}
.loginpage.container {
  width: 100vw;
}
input[type='password'] {
  color: black;
}
</style>
<style scoped>
.loginsubmitwrp {
  position: relative;
  text-align: center;
  color: #444;
}

.loginsubmitwrp a {
  position: relative;
  display: inline-block;
  left: 0;
  margin: 0 0 20px 0;
  /* color: #444; */
  font-size: 14px;
}
.logincntr {
  height: 307px;
}
.loginsubmitwrp button {
  position: relative;
  padding: 0 30px;
  line-height: 45px;
  display: block;
  text-align: center;
  margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// Login.vue?3be7079c